import { http } from '@/utils'
import { LoginParams, feedbackParams, LoginResp } from './type'

export enum authApi {
	getCurrentUserInfo = '/auth-api/api/v1/auth/login/getUserInfo',
	login = '/auth-api/api/v1/auth/login',
	captcha = '/auth-api/api/v1/auth/login/captcha',
	log = '/auth-api/api/v1/auth/login/loginLog'
}

// * 用户登录
export const loginApi = (data: LoginParams) => {
	return http.post<LoginResp>(authApi.login, {
		params: data
	})
}
// * 用户退出
export const logout = (refreshToken: string, app: string) => {
	return http.post('/auth-api/api/v1/auth/login/logout', { params: { refreshToken, app: 'km' } })
}
// * 用户信息
export const getCurrentUserInfoApi = () => {
	return http.get<NKmUser.UserInfo>(authApi.getCurrentUserInfo, {})
}

// * 获取验证码
export const captchaApi = () => {
	return http.get<{ base64: string; uuid: string }>(authApi.captcha, {
		getParams: {}
	})
}

// * 登录日志
export const loginLog = () => {
	return http.get<any>(authApi.log, {})
}

// * 反馈
export const feedback = (data: feedbackParams) => {
	return http.post('/op-api/api/v1/op/feedback/insert', { params: data })
}
// * 反馈列表
export const feedbackList = () => {
	return http.get('/op-api/api/v1/op/feedback/historyQuestionPage?person', { params: {} })
}
// 刷新token
export const getTokenByRefreshToken = (refreshToken: string) => {
	return http.post<LoginResp>('/auth-api/api/v1/auth/login/refreshToken', { params: { refreshToken, app: 'km' } })
}
// 判断系统管理员权限
export const isSystemAdminApi = () => {
	return http.get('/op-api/api/v1/km/isSystemAdmin', { params: {} })
}
